import axios from 'axios';

let Api_Url="";

const setApiUrl = (url) => {
  Api_Url = url;
  //alert(Api_Url);
};

const Service = {
  setApiUrl, // expose setter
  // ADD THIS
getCategories: () => axios.get(Api_Url),
  getAll: () => axios.get(Api_Url),
   getById: (id) => axios.get(`${Api_Url}/${id}`),


   getReport: (empNo, fromDate, toDate) =>
  axios.get(
    `${Api_Url}/Report/${empNo}/${fromDate}/${toDate}`
  ),

  loadCategory: (id,dropdownType) => axios.get(`${Api_Url}/${id}/${dropdownType}`),
  loadUsername: (id,dropdownType) => axios.get(`${Api_Url}/${id}/${dropdownType}`),
  loadUserGroup: (id,dropdownType) => axios.get(`${Api_Url}/${id}/${dropdownType}`),

   
  loadMenuDtls: (opFlag,groupID) => axios.get(`${Api_Url}/Menu-Dtls/${opFlag}/${groupID}`),   
  //loadSideBarMnus: (usrNm,opFlag) => axios.get(`${Api_Url}/Menu-SideBar/${usrNm}/${opFlag}`),


//new
  // Dashboard Div Access
getDashboardDivAccess: (groupID, menuID) =>
  axios.get(`${Api_Url}/DashboardDivAccess/${groupID}/${menuID}`),
//new
saveDashboardDivAccess: (data) =>
  axios.post(`${Api_Url}/DashboardDivAccess`, data),

//use for vendor view 
getDashboardDivAccessByEmpNo: (groupID, empNo, menuID) =>
  axios.get(
    `${Api_Url}/DashboardDivAccessByEmpNo/${groupID}/${empNo}/${menuID}`
  ),

  loadSideBarMnus: (usrNm, opFlag, platform = "W") =>axios.get( `${Api_Url}/Menu-SideBar/${usrNm}/${opFlag}/${platform}`),

  //  create: (data) => axios.post(Api_Url, data),
  create: (data) => {
  console.log("POST URL =", Api_Url);
  return axios.post(Api_Url, data);
},
 
  //update: (id, data) => axios.put(`${Api_Url}/${id}`, data),
  remove: (id,opFlag) => axios.delete(`${Api_Url}/${id}/${opFlag}`),
  getVndrAprvrDtls: (vUserName) => axios.get(`${Api_Url}/${vUserName}`),
  updateVendorApproval: (data) => axios.post(Api_Url, data),

  getVendorApprovalStatus: () =>
    axios.get(`${Api_Url}/Status`),
  getApprovalHistory: (vendorId) =>
  axios.get(`${Api_Url}/History/${vendorId}`),
  getVisibleMenus: (groupId) => axios.get(`${Api_Url}/VisibleMenus/${groupId}`),
};

export default Service;
